import { render, staticRenderFns } from "./CoursesListFilters.vue?vue&type=template&id=7b23ec4d&"
import script from "./CoursesListFilters.vue?vue&type=script&lang=js&"
export * from "./CoursesListFilters.vue?vue&type=script&lang=js&"
import style0 from "./CoursesListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports